// react core
// import { useState, useEffect } from "react";

// theming
import mainTheme from "components/main/MainTheme";
import { ThemeProvider, responsiveFontSizes } from "@mui/material/styles";

// material design
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
// import Typography from "@mui/material/Typography";

// entzy config models and components
import HomeLanding from "./HomeLanding";
import HomeMembers from "./HomeMembers";

// entzy hooks
import { useMainRedirect } from "hooks/main/mainRedirect";

function HomeIndexPublic(props) {
  return (
    <Box className="box-default">
      <HomeLanding {...props} />
    </Box>
  );
}

function HomeIndexConnected(props) {
  return (
    <Box className="box-default">
      <Container maxWidth="lg" disableGutters>
        <HomeMembers {...props} />
      </Container>
    </Box>
  );
}

function HomeIndex(props) {
  // capture redirect on connect
  useMainRedirect(props);

  return (
    <ThemeProvider theme={responsiveFontSizes(mainTheme)}>
      <Box className="box-default">
        {props.user.connected ? (
          <HomeIndexConnected {...props} />
        ) : (
          <HomeIndexPublic {...props} />
        )}
      </Box>
    </ThemeProvider>
  );
}

export default HomeIndex;
